/**
 * @description
 *
 * Помещает URL в историю браузера.
 *
 * @param {string} url - страница записи
 * @param {object} state - данные состояния
 */

function pushHistoryState(url, state) {
  window.history.pushState(state, null, url)
}

export default pushHistoryState
